import { Authenticator,View,Image, Heading,Flex} from '@aws-amplify/ui-react';
import MainView from './pages/Home';
import './App.css';
import logo from './Logo.png';

import { I18n } from 'aws-amplify';
import { translations } from '@aws-amplify/ui-react';
I18n.putVocabularies(translations);
I18n.setLanguage('es');


/** 
 * Componente inicial de la aplicación
 * @return la vista para realizar el proceso de autenticación y cargar la vista principal en caso de ser correcta la autenticación  
 */
export default function App() {

  //BOTON DE SIGN OUT  <button onClick={signOut}>Sign out</button>

  /**
   * Configuración de los campos de inicio de sesion
   */
  const formFields = { 
    signIn:{
      username:{
        placeholder: 'Usuario',
        isRequired: true,
        labelHidden: true
      },
      password:{
        placeholder: 'Contraseña',
        isRequired: true,
        labelHidden: true
      }
    },
    forceNewPassword: {
      password: {
        placeholder: 'Ingrese su contrasña',
      },
    }
  }

  /**
   * Configuración de los componentes que hacen parte del autenticador
   */
  const components = {
    SignIn:{
      Header(){
        return(
          <Flex
            direction="column"
          >
            <Image
              height="400px"
              width="100%"
              alt="Ailanto logo"
              src={logo}
            />
            <Heading level={2} textAlign="center">
              Inicio de Sesión
            </Heading>
          </Flex>
        );
      },
      Footer(){
        return(
          <View textAlign="center"></View>
        );
      }
    }
  }


  return (
    <Flex alignItems="center" justifyContent="center" height="100vh"> 
      <Authenticator
        formFields={formFields}
        components={components}
        hideSignUp={true}
        hideForgotPassword={true}
        class = 'sigIn-container'
      >
        {({ signOut, user, error }) => (
          <main className='mainView'>
            <MainView 
              signOut={signOut} 
              user={user}
            />
          </main>
        )}
      </Authenticator>    
    </Flex>
  );

}